import {Pipe, PipeTransform} from '@angular/core';
import {CacheService} from '../core/cache.service';
import {keyBy} from 'lodash-es';

@Pipe({
  name: 'category'
})
export class CategoryPipe implements PipeTransform {

  categories;

  constructor(private cache: CacheService) {
    this.categories = keyBy(this.cache.getCache('itemCategory').filter(c => !!c.icCatCode || c.icId === 99), 'icId');
  }

  transform(value: string, ...args: unknown[]): unknown {
    return this.categories[value] ? this.categories[value].icDesc : value;
  }

}
